import constants from "../../core/constants";
import isNil from "lodash/fp/isNil";
import each from "lodash/fp/each";
const isString = (text) => typeof text === "string";
class RouteName {
  constructor() {
    return this.transform;
  }

  transform(array, text) {
    if (isNil(array)) return array;
    if (isNil(text)) return array;
    const searchText =
      isString(text) && text.length
        ? text.split(" ").splice(0, constants.defaultTrimWordsCount).join(" ")
        : text;
    const result = [];
    each((element) => {
      const name = String(element.route.name).toLowerCase();
      if (name.indexOf(searchText.toLowerCase()) !== -1) {
        result.push(element);
      }
    })(array);

    return result;
  }
}

const routeNameFnc = () => new RouteName();

export default routeNameFnc;



// WEBPACK FOOTER //
// ./src/filters/routeName/routeName.filter.js